import React from 'react';
import MainSection from './sections/MainSection.js';
import AdvantagesSection from './sections/AdvantagesSection.js';
import LocationsRoutesSection from './sections/LocationsRoutesSection.js';
import RecommendationsSection from './sections/RecommendationsSection.js';
import Header from '../../components/layout/Header/Header.js';
import Footer from '../../components/layout/Footer/Footer.js';

//import './Main.css';

const MainPage = () => {
  return (
    <div id="container" className="flex-column">
      <Header />
      <MainSection />
      <AdvantagesSection />
      <LocationsRoutesSection />
      <RecommendationsSection />
      <Footer />
    </div>
  );
};

export default MainPage;